import React from 'react';
import CustomCollapsible from '../generalPurpose/CustomCollapsible';
import POCToolContent from './POCToolSinglePageContent/POCToolContent';
import POCToolSubtopic from './POCToolSubtopic';
import {Topic} from '../../../models/IPOCToolWebPortal';

type Props = {
  topic: Topic;
  isOpen: boolean;
};

export default function POCToolTopic(props: Props) {
  const {topic, isOpen} = props;

  return (
    <CustomCollapsible
      key={topic.id}
      title={topic.name}
      containerStyle={styles.topicContainer}
      itemHeaderContainerStyle={styles.topicItemHeaderContainer}
      fontStyle={styles.fontStyle}
      isOpen={isOpen}>
      {[...topic.content, ...topic.subTopics]
        .sort((a, b) => a.order - b.order)
        .map((item, index) => {
          if (item.type) {
            return (
              <POCToolContent
                key={item.id}
                content={item}
                contentIndex={index}
                contentLength={topic.content.length}
              />
            );
          } else {
            return (
              <POCToolSubtopic key={item.id} subTopic={item} isOpen={isOpen} />
            );
          }
        })}
    </CustomCollapsible>
  );
}

const styles = {
  topicContainer: {
    borderWidth: 0,
    paddingVertical: 0,
    marginBottom: 8,
    marginLeft: 20,
    marginRight: 20,
  },
  topicItemHeaderContainer: {
    backgroundColor: '#B9DDFF',
    paddingLeft: 16,
    paddingRight: 16,
    borderRadius: 4,
    paddingVertical: 15,
  },
  fontStyle: {
    fontSize: 18,
    fontWeight: 'bold',
    fontcolor: '#000000',
  },
};
